import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../../../utils/functions/globalDialog';

// dialog ยืนยันอนุมัติ/ปฏิเสธ/รอก่อน (หรือ ตรวจสอบแล้ว/พบปัญหา/รอก่อน) + หมายเหตุ รองรับทั้ง single-row
// (handleAction) และ bulk (handleBulkAction) — reuse dialog เดียวกัน (actionDialog.rows รองรับทั้ง 1 และ
// หลายแถว) onSaved เรียกหลัง submit สำเร็จ ให้ผู้เรียก refetch rows/tabCounts/ล้าง selection เอง (ไม่ผูก
// concern พวกนั้นไว้ในนี้ตรงๆ) — action ที่ยิงจริงมาจาก mode.setStatusAction (constants/modes.js)
export function useQueueAction({ mode, rows, selectedIds, onSaved }) {
  const dispatch = useDispatch();
  const [actionDialog, setActionDialog] = useState(null); // { rows: [row, ...], action }
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const handleAction = (row, action) => {
    setActionDialog({ rows: [row], action });
    setNote('');
  };

  const handleBulkAction = (action) => {
    const selectedRows = rows.filter((r) => selectedIds.has(r._id));
    if (selectedRows.length === 0) return;
    setActionDialog({ rows: selectedRows, action });
    setNote('');
  };

  const submitAction = async () => {
    if (!actionDialog?.rows?.length) return;
    setBusy(true);
    try {
      const payload = { action: actionDialog.action, note };
      const applyToRow = (r) =>
        dispatch(mode.setStatusAction(r._id, payload));
      await Promise.all(actionDialog.rows.map(applyToRow));
      showAlert('บันทึกสำเร็จ');
      setActionDialog(null);
      onSaved?.();
    } catch (err) {
      showAlert('เกิดข้อผิดพลาด', { status: err?.response?.status });
    } finally {
      setBusy(false);
    }
  };

  return {
    actionDialog,
    setActionDialog,
    note,
    setNote,
    busy,
    handleAction,
    handleBulkAction,
    submitAction,
  };
}
